import React from "react";
import styled from "@emotion/styled";
import { Flex } from "styles/utility-components";

import Button from "components/ui/button/Button";
import EmptyState from "components/ui/empty_state/EmptyState";

type LeadResultsEmptyStateProps = {
  onClearFilters: () => void;
};

function LeadResultsEmptyState({ onClearFilters }: LeadResultsEmptyStateProps) {
  return (
    <Wrapper>
      <EmptyState
        type="noResults"
        heading="No results"
        description="We don't have any results matching your filters. Try clearing your filters to see your leads"
        width="100%"
        size="large"
        action={<Button onClick={onClearFilters}>Clear filters</Button>}
      />
    </Wrapper>
  );
}

const Wrapper = styled(Flex)({
  maxWidth: 290,
});

export default LeadResultsEmptyState;
